export default __webpack_public_path__ + "static/media/sub-category-coworking-OfficeSpace.9ad0d6a5.jpg";